import React,{useState} from 'react'

const ProjectLevelDefitions = () => {
  
     const [showPopup, setShowPopup] = useState(false);
  
    const definitions = [
      {
  title: "Snapshot View",
  visual: "",
  description: "Provides a high-level overview of case distribution. It includes the total number of open cases, DS cases, BR cases, and aborted cases. This view helps stakeholders quickly assess the overall project status at a glance."
},
{
  title: "Current Open",
  visual: "Cards",
  description: "Displays the current count of open cases that are yet to be resolved or closed. This helps in understanding the present workload and pending actions."
},
{
  title: "Current DS",
  visual: "Cards",
  description: "Shows the current number of cases in the DS (Docket Submitted) stage. This allows tracking of how many cases are progressing through the DS process at the moment."
},
{
  title: "Current BR",
  visual: "Cards",
  description: "Represents the cumulative count of cases that have successfully reached the BR (Benefits Received) stage. This provides an indicator of the actual outcomes and impact achieved so far."
},
{
  title: "Work Done View",
  visual: "",
  description: "Highlights the progress made during a given time period. It measures the completed work in terms of case movements across different stages, enabling performance tracking and monitoring against set goals."
}
,
      {
        title: "Organization Name",
        visual: "Multi Selected Filter",
        description: "Choose the Organization name (State), which corresponds to the state associated with the selected PID."
      },
      {
        title: "Service Type",
        visual: "Multi Selected Filter",
        description: "Choose the service type associated with the selected pid to filter the data."
      },
      {
        title: "SchemeName",
        visual: "Multi Selected Filter",
        description: "Choose the Scheme Name ,A filter used to display schemes associated with the selected pid to filter the data."
      },
      {
        title: "Start Date",
        visual: "Filter",
        description: "Choose the start date for see data in fixed time period."
      },
      {
        title: "End Date",
        visual: "Filter",
        description: "Choose the end date for see data in fixed time period."
      },
       {
        title: "Citizens Screened",
        visual: "Metric",
        description: "Total number of citizens who have been screened."
      },
      {
        title: "Application Open",
        visual: "Metric",
        description: "This shows the total count of schemes applications that are Opened."
      },
      {
        title: "Docket Submitted",
        visual: "Metric",
        description: "This shows the total count of scheme applications in 'DS' (Document Submitted).",
        bullets: [
          "Document Submitted: Status when the application's proof of submission is uploaded to the case"
        ]
      },
      {
        title: "BR Count",
        visual: "Metric",
        description: "This shows the total count of scheme applications in 'BR' (Benefit Received) status.",
        bullets: [
          "Benefit Received: Status when the application's proof of benefit is uploaded to the case on the app"
        ]
      },
      {
        title: "Aborted Cases",
        visual: "Metric",
        description: "Total number of cases that have been marked as aborted during the processing stage."
      },

      {
        title: "Benefit Value",
        visual: "Metric",
        description: "The total value of benefits that have been unlocked."
      },
      {
        title: "State wise Statistics",
        visual: "Column Chart",
        description: "A column chart displaying the number of applications per state under the statuses: Open, Docket Submitted, and Benefit Received (BR)."
      },
      {
        title: "Summary Status",
        visual: "Column Chart",
        description: "A column chart showing the number of Benefit Received (BR) applications week by week. Users can apply filters such as Organization Name, District, Scheme, and Target Type to view the data based on selected criteria."
      },
      {
        title: "Gender Distribution",
        visual: "Pie Chart",
        description: "A pie chart showing the count of citizens categorized by gender: Male, Female, and Other."
      },
      {
        title: "Age Distribution",
        visual: "Column Chart",
        description: "A column chart showing the count of citizens grouped by age ranges: <18, 18–25, 26–45, and >45, representing the age-wise distribution."
      },{
        title: "Click here to see DFL Camps Dashboard",
        visual: "button",
        description: "It redirects on DFL Camps Dashboard Where all dfl camps regarding insigths are available ."
      }
  ];
  
    return (
      <div className="relative">
        <button
  onClick={() => setShowPopup(true)}
  className="ml-3 inline-flex items-center px-3 py-1.5 rounded-md bg-blue-50 text-blue-700 border border-blue-200 
             hover:bg-blue-100 hover:border-blue-300 transition-all duration-200 text-sm font-medium shadow-sm"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-4 w-4 mr-2 text-blue-500"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M12 18a9 9 0 100-18 9 9 0 000 18z" />
  </svg>
  Click here to see KPI Definitions
</button>
  
        {showPopup && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-auto">
              <div className="p-6">
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-xl font-bold text-black ">KPI Definitions</h2>
                  <button 
                    onClick={() => setShowPopup(false)}
                    className="text-gray-500 hover:text-gray-700"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>
                
                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-gray-200 border border-gray-300">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-6 py-3 text-left text-lg font-bold text-gray-700 uppercase tracking-wider border border-gray-300 ">KPI</th>
                        <th className="px-6 py-3 text-left text-lg font-bold text-gray-700 uppercase tracking-wider border border-gray-300">Definition</th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {definitions.map((item, index) => (
                        <tr key={index}>
                          <td className="px-3 py-2 whitespace-nowrap border border-gray-300">
                            <div className="font-bold text-gray-900 text-left text-sm ">{item.title}</div>
                            {item.visual && (
                              <div className="text-sm text-blue-600 mt-1">{item.visual}</div>
                            )}
                          </td>
                          <td className="px-3 py-2 border border-gray-300">
                            <div className="text-sm text-gray-900  text-left">{item.description}</div>
                            {item.bullets && (
                              <div className="mt-2">
                                <span className="font-bold text-sm text-black">Details:</span>
                                <ul className="list-disc list-inside text-sm text-gray-600 font-bold text-left">
                                  {item.bullets.map((bullet, i) => (
                                    <li key={i} className='mb-2'>{bullet}</li>
                                  ))}
                                </ul>
                              </div>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                
                <div className="mt-6 flex justify-end">
                  <button
                    onClick={() => setShowPopup(false)}
                    className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 transition-colors"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
  )
}

export default ProjectLevelDefitions
